import { decodeJWT } from '../utils/jwtUtil';
import { getCookie, removeCookie } from '../utils/cookiesUtils';

export function checkSessionExpiration() {
    const intervalId = setInterval(() => {
        const dashboard_token = getCookie('dashboard_token');

        if (dashboard_token) {
            try {
                const token_data = decodeJWT(dashboard_token);

                if (token_data) {
                    if ((token_data.exp * 1000) < new Date().getTime()) {
                        handleSessionExpired();
                    }
                }
                else {
                    handleSessionExpired();
                }
            }
            catch (error) {
                handleSessionExpired();
            }
        }
        else {
            handleSessionExpired();
        }

    }, 300000);

    return intervalId;
}

function handleSessionExpired() {
    removeCookie('dashboard_token');
    window.location.href = '/login';
}
